import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CAPABILITIES } from "@/data/capabilities";
import { SITE } from "@/data/site";
import { Overline } from "@/components/shared/Primitives";
import { EASE } from "@/components/shared/motion";

const WORDMARK_INITIAL = { y: "40%", opacity: 0 };
const WORDMARK_IN_VIEW = { y: "12%", opacity: 1 };
const WORDMARK_TRANSITION = { duration: 1.4, ease: EASE };
const WORDMARK_VIEWPORT = { once: true };

export const COLUMNS = [
  {
    heading: "Studio",
    links: [
      { label: "Work", to: "/work" },
      { label: "Capabilities", to: "/capabilities" },
      { label: "Experiments", to: "/experiments" },
      { label: "About", to: "/about" },
      { label: "Start a Project", to: "/start-a-project" },
    ],
  },
  {
    heading: "Capabilities",
    links: CAPABILITIES.map((c) => ({ label: c.name, to: `/capabilities/${c.slug}` })),
  },
];

export const FooterBrand = () => (
  <div>
    <p className="font-display text-2xl font-bold uppercase tracking-[0.3em] text-[#F4F6FB]">
      Elentara
    </p>
    <p className="mt-4 font-mono text-[11px] uppercase tracking-[0.3em] text-[#06B6D4]">
      {SITE.positioning}
    </p>
    <p className="mt-6 max-w-xs text-sm leading-relaxed text-[#F4F6FB]/55">{SITE.statement}</p>
    <a
      href={`mailto:${SITE.email}`}
      data-testid="footer-email-link"
      className="mt-8 inline-block font-mono text-[11px] uppercase tracking-[0.25em] text-[#F4F6FB]/70 transition-colors duration-300 hover:text-[#06B6D4]"
    >
      {SITE.email}
    </a>
    <div className="mt-6 flex items-center gap-5">
      {SITE.social.map((s) => (
        <a
          key={s.label}
          href={s.href}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`footer-social-${s.label.toLowerCase()}`}
          className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#F4F6FB]/45 transition-colors duration-300 hover:text-[#F4F6FB]"
        >
          {s.label} ↗
        </a>
      ))}
    </div>
  </div>
);

export const FooterColumn = ({ column }) => (
  <nav aria-label={column.heading}>
    <Overline className="mb-6 !text-[10px] !tracking-[0.35em] text-[#F4F6FB]/40">
      {column.heading}
    </Overline>
    <ul className="space-y-4">
      {column.links.map((link) => (
        <li key={link.label}>
          <Link
            to={link.to}
            data-testid={`footer-link-${link.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            className="font-mono text-[11px] uppercase tracking-[0.22em] text-[#F4F6FB]/55 transition-colors duration-300 hover:text-[#06B6D4]"
          >
            {link.label}
          </Link>
        </li>
      ))}
    </ul>
  </nav>
);

export const FooterWordmark = () => (
  <div className="pointer-events-none relative select-none overflow-hidden" aria-hidden="true">
    <motion.p
      initial={WORDMARK_INITIAL}
      whileInView={WORDMARK_IN_VIEW}
      viewport={WORDMARK_VIEWPORT}
      transition={WORDMARK_TRANSITION}
      className="text-outline font-display whitespace-nowrap text-center text-[18vw] font-black uppercase leading-[0.85]"
    >
      Elentara
    </motion.p>
  </div>
);
